import React from "react";
import MovementForm from "@/components/MovementForm";

export default function QuickRegister() {
  return (
    <div className="py-4 max-w-2xl" data-testid="quick-register-page">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Registro rápido</h1>
      <p className="text-muted-foreground text-sm mt-1 mb-8">Captura un movimiento en segundos. Toma la foto del ticket y deja que la IA lo llene.</p>
      <MovementForm />
    </div>
  );
}
